<div class="ols-title">{{vraagtitel}}</div>
<div *ngFor="let regel of vraag.vraagregels" [innerHTML]="regel"></div>
<div class="vraag__actions">
  <div class="buttons-container">
    <a [href]="vraag.button_link" class="button has-ripple js-ext-url" title="Naar mobiel schade melden"
      aria-label="Naar mobiel schade melden" role="button"
      [attr.data-popup-titel]="popupTitel"
      [attr.data-popup-tekst]="popupTekst"
      [attr.data-popup-btekst]="popupButtonTekst"
      [attr.data-popup-image]="popupImage"
      data-popup-image-alt="logo mobiel schade melden"
      data-popup-class="msm"
      data-popup-arialabel="venster naar mobiel schade melden"
      id="ipoclick-btn-{{geefPazaProces()}}-kiezer-naar_msm">{{button_text1}}</a>
  </div>
</div>
<br>
<div *ngIf="vraag.stappenplan_detail" [innerHTML]="vraag.stappenplan_detail"></div>
<div class="vraag__actions">
  <div class="buttons-container">
    <a (click)="eindeVerzekeringkiezer()" class="button button--outline has-ripple"
      id="ipoclick-btn-{{geefPazaProces()}}-kiezer-start_schademelden">{{button_text2}}</a>
  </div>
</div>